import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _EmbersTemplateBo, _styled;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT, PROMETHEAN_TEXT_HEADER, PROMETHEAN_NEUTRAL_WHITE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_H2, PROMETHEAN_TYPOGRAPHY_H4, PROMETHEAN_TYPOGRAPHY_SUBTITLE_01, PROMETHEAN_TYPOGRAPHY_BODY } from '../styles/typography/typography';
import { EmbersGrid } from '../grid/grid';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE, PROMETHEAN_BREAKPOINT_CONTENT_AREA_MAX_WIDTH, PROMETHEAN_BREAKPOINT_XL } from '../styles/breakpoints/breakpoints';
var NAV_WIDTH = 280;
export var StyledTemplate = styled('div')({
  width: '100%',
  height: '100%',
  '&.EmbersTemplate-withNav': {
    '.EmbersTemplate-nav': _defineProperty({}, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE + 1, "px)"), {
      width: NAV_WIDTH
    }),
    '&>.EmbersTemplate-body > .EmbersTemplate-content': (_EmbersTemplateBo = {}, _defineProperty(_EmbersTemplateBo, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE + 1, "px)"), {
      maxWidth: "calc(100% - ".concat(NAV_WIDTH, "px)") //left navBar's width is 280px
    }), _defineProperty(_EmbersTemplateBo, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_CONTENT_AREA_MAX_WIDTH, "px)"), {
      maxWidth: 1480
    }), _defineProperty(_EmbersTemplateBo, "marginLeft", 0), _EmbersTemplateBo),
    '&.EmbersTemplate-mobile': {
      '.EmbersTemplate-body': {
        '.EmbersTemplate-nav': {
          padding: 0
        }
      }
    }
  },
  '>.EmbersTemplate-appTitle.EmbersTitle-root.EmbersTitle-appTitle': {
    paddingRight: 'calc(100% - 100vw + 24px)'
  },
  '.EmbersTemplate-body': {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    '.EmbersTemplate-nav': {
      paddingTop: 24,
      paddingLeft: 24,
      marginBottom: 40
    }
  }
});
export var StyledTemplateContent = styled(EmbersGrid)((_styled = {
  marginBottom: 40,
  alignSelf: 'baseline',
  maxWidth: 1712,
  marginLeft: 'auto',
  marginRight: 'auto',
  '&.EmbersTemplate-hasTitlePostfix': {
    '.EmbersTextTooltip-noWrap': {
      flexGrow: 0,
      flexBasis: 'auto'
    }
  },
  '& > .MuiGrid-item': {
    paddingLeft: 0,
    height: '100%'
  }
}, _defineProperty(_styled, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"), {
  paddingLeft: 16,
  // when there is a scroller, scrollerWidth = 100vw - 100%, remove the scrollerWidth from padding here
  paddingRight: 'calc(100% - 100vw + 16px)',
  width: '100%'
}), _defineProperty(_styled, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE + 1, "px)"), {
  paddingLeft: 24,
  paddingRight: 'calc(100% - 100vw + 24px)'
}), _defineProperty(_styled, '.EmbersTemplate-row', {
  maxWidth: 'calc(100% + 16px)',
  rowGap: 24,
  '.EmbersTemplate-rowTitle': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_01), {}, {
    color: PROMETHEAN_TEXT_HEADER,
    marginTop: 8,
    marginBottom: -8
  })
}), _defineProperty(_styled, '&.EmbersTemplate-full', {
  width: '100%',
  padding: '0',
  marginBottom: 80
}), _defineProperty(_styled, '&.EmbersTemplate-card', {
  marginBottom: 40,
  '.MuiGrid-container.EmbersTemplate-row .EmbersCard-root': {
    height: '100%' //'calc(100% - 16px)' can't remember why this originally subtracted 16 from height
  },

  '> .MuiGrid-root > :not(:last-child)': {
    marginBottom: 16
  },
  '.EmbersCard-root': {
    marginTop: 0
  }
}), _defineProperty(_styled, '&.EmbersTemplate-error', {
  paddingTop: 40,
  marginBottom: 105,
  color: PROMETHEAN_TEXT_HEADER,
  '> .EmbersGrid': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '.errorTemplate-root': {
    maxWidth: 684,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    rowGap: 40,
    '&.errorTemplate-mobile': {
      '.errorTemplate-header': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_H4), {}, {
        color: PROMETHEAN_TEXT_HEADER
      }),
      '.errorTemplate-image': {
        width: 300
      }
    },
    img: {
      height: 'auto',
      width: '100%'
    },
    '.errorTemplate-image': {
      minWidth: 300
    },
    '.errorTemplate-header': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_H2), {}, {
      color: PROMETHEAN_TEXT_HEADER
    }),
    '.errorTemplate-body': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
      color: PROMETHEAN_TEXT,
      fontWeight: 400
    })
  }
}), _styled));

// ToDo: figure out why cards unit test complains that Card here doesn't exist when I try to use it here
export var StyledBarCard = styled('div')({
  // borderLeft: `8px solid ${PROMETHEAN_PURPLE_GRAPE}`,
  '&.BarCard-body': {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 24,
    p: {
      paddingBottom: 16
    }
  }
});
export var StyledInfoCard = styled('div')({
  '&.InfoCard-body': {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 16,
    p: {
      paddingBottom: 16
    }
  }
});
export var StyledHomeSection = styled('div')(_defineProperty({
  margin: '64px auto',
  width: 1536
}, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_XL, ")"), {
  width: 1280
}));
export var StyledHomeSectionColumn = styled(EmbersGrid)(function (_ref) {
  var columnCount = _ref.columnCount;
  return {
    '@media screen and (min-width: 769px)': {
      flexBasis: "".concat(100 / columnCount, "%"),
      maxWidth: "".concat(100 / columnCount, "%")
    },
    '@media screen and (max-width: 760px)': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      padding: '0 72px',
      p: {
        textAlign: 'center'
      }
    },
    '@media screen and (max-width: 375px)': {
      padding: '0 40px'
    },
    '.homeSection-circle': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      width: 72,
      height: 72,
      i: {
        color: PROMETHEAN_NEUTRAL_WHITE,
        fontSize: '52px'
      }
    }
  };
});
export var StyledHomeBanner = styled('div')({
  width: '100%',
  background: 'linear-gradient(215.35deg, #5D3C7A 16.25%, #282036 69.99%)',
  display: 'flex',
  flexDirection: 'column',
  '.homeTemplate-banner-logo': {
    width: 120,
    height: 30,
    margin: '32px 0 0 48px',
    '@media screen and (max-width: 376px)': {
      margin: '32px auto 0'
    }
  }
});